var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDwnldbtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627",
    transform: "translate(-1186 -101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 24,
    height: 24,
    transform: "translate(1186 101)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    d: "M-6524.285,15317.508a.713.713,0,0,1-.619-.357.714.714,0,0,1,0-.714.713.713,0,0,1,.619-.357h15.719a.713.713,0,0,1,.619.357.714.714,0,0,1,0,.714.713.713,0,0,1-.619.357Zm7.354-4.161-4.1-4.1a.716.716,0,0,1-.175-.687.717.717,0,0,1,.5-.5.717.717,0,0,1,.686.176h0l2.878,2.877v-10.4a.715.715,0,0,1,.209-.506.716.716,0,0,1,.505-.209.716.716,0,0,1,.505.209.715.715,0,0,1,.209.506v10.4l2.877-2.877a.71.71,0,0,1,.508-.218.712.712,0,0,1,.511.209.714.714,0,0,1,.209.512.716.716,0,0,1-.218.508l-4.1,4.1a.714.714,0,0,1-.5.209A.716.716,0,0,1-6516.931,15313.347Zm.505-13.344Z",
    transform: "translate(7714.426 -15196.002)",
    fill: "#f17456"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwnldbtn);
export default __webpack_public_path__ + "static/media/dwnldbtn.eb94899466dea141a76207ee1ee5a034.svg";
export { ForwardRef as ReactComponent };